import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['filter', 'option', 'dropdown', 'checkbox', 'amount', 'selectImage', 'filterArrow', 'tagLink']
  static values = {
    name: String,
    values: Array
  }

  connect() {
    this.values = [];

    // Слушаем события об изменении фильтра для синхронного изменения выбранных опций
    this.element.addEventListener(`filter-${this.nameValue}-updated`, this.onFilterUpdated.bind(this))
  }

  onFilterUpdated(event) {
    // console.log('onFilterUpdated FILTER', {event})
    this.values = event.detail.values
    this.updateSelectedOptions()
    this.updateSelectedAmount()
  }

  updateSelectedOptions() {
    // console.log('updateSelectedOptions FILTER')
    const items = this.checkboxTargets
    items.forEach(item => {
      const isChecked = this.values.includes(item.value)
      item.checked = isChecked

      const selectImage = this.selectImageTargets.find(img => img.dataset.id === item.dataset.id)
      if (selectImage) {
        selectImage.style.display = isChecked ? 'block' : 'none'
      }
    })
  }

  toggleDropdown() {
    const dropdownEl = this.dropdownTarget;
    const arrowEl = this.filterArrowTarget;

    const isOpen = dropdownEl.classList.toggle('open');
    arrowEl.classList.toggle('open', isOpen);
    // console.log('toggleDropdown FILTER', {isOpen, dropdownEl, arrowEl})
    if (isOpen) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  handleClickOutside = (event) => {
    // console.log('handleClickOutside FILTER', {event})
    if (!this.element.contains(event.target)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    const dropdownEl = this.dropdownTarget;
    const arrowEl = this.filterArrowTarget;
    // console.log('closeDropdown FILTER', {arrowEl, dropdownEl})
    dropdownEl.classList.remove('open');
    arrowEl.classList.remove('open');

    document.removeEventListener('click', this.handleClickOutside);
  }

  applyFilter() {
    const detail = {
      name: this.nameValue,
      values: this.values
    }
    // console.log('applyFilter FILTER', {detail})

    this.dispatch('filter-applied', {detail});
  }

  updateSelectedAmount() {
    const amountEl = this.amountTarget;
    const valuesLength = this.values.length;
    amountEl.textContent = valuesLength > 0 ? ` (${valuesLength})` : '';
    // console.log('updateSelectedAmount FILTER', { amountEl, valuesLength });
  }

  toggleCheckbox(event) {
    const id = event.currentTarget.dataset.id;
    const checkbox = this.checkboxTargets.find(cb => cb.dataset.id === id);
    const selectImage = this.selectImageTargets.find(img => img.dataset.id === id);
    // console.log('toggleCheckbox FILTER', { event, id, checkbox, selectImage });
    checkbox.checked = !checkbox.checked;
    selectImage.style.display = checkbox.checked ? 'block' : 'none';

    const value = checkbox.value
    if (checkbox.checked) {
      if (!this.values.includes(value)) this.values.push(value)
    } else {
      this.values = this.values.filter(v => v !== value)
    }

    this.updateSelectedAmount()
    this.applyFilter()
  }

  sortItems(event) {
    const sortOption = event.target.textContent
    // console.log(`Sorting by: ${sortOption}`)
    // Здесь будет логика сортировки
  }
}
